import { toast } from 'react-toastify';
import * as yup from 'yup';

import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import { trans } from '../../../localization/index';
import {
  formatEndDateTime,
  formatStartDateTime,
  getIdsPaging,
  isEmpty,
  isSuccess,
} from '../../../utils/utils';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { EnumToggleType } from '../../../constants/enum';

export function receiveListTableManagementInfo(itemData) {
  return {
    type: actions.RECEIVE_LIST_TABLE_MANAGEMENT_INFOS,
    response: {
      itemData,
    },
  };
}

export function changeOrderTableItem({ key, value, itemEdit }) {
  return {
    type: actions.CHANGE_ORDER_TABLE_ITEM,
    response: {
      key,
      value,
      itemEdit,
    },
  };
}

export function receiveListTableManagementIds(itemList, itemData) {
  return {
    type: actions.RECEIVE_LIST_TABLE_MANAGEMENT_IDS,
    response: {
      itemList,
      itemData,
    },
  };
}

export function getListInfo(ids, isAfterGetIds = false) {
  function genBody(state, merchantTableInfos) {
    const { filters } = state;
    const { merchant } = filters;
    const merchantIds = merchant.value !== 0
      ? [merchant.value]
      : merchantTableInfos.map(merchantTableInfo => merchantTableInfo.id);

    return {
      order_ids: ids,
      merchant_ids: merchantIds,
    };
  }
  return (dispatch, getState) => {
    if (ids.length === 0) {
      return Promise.resolve({});
    }
    const state = getState().table.order;
    const { merchantTableInfos } = getState().app;
    const body = genBody(state, merchantTableInfos);

    if (!isAfterGetIds) {
      dispatch(startAppLoading());
    }
    return request
      .postTableNow('/api/merchant_tool/get_order_infos', body)
      .then(response => {
        if (isSuccess(response)) {
          const { order_infos: orderInfos } = response.reply;
          const itemData = orderInfos.reduce(
            (map, item) => ({ ...map, [item.id]: item }),
            {},
          );
          if (!isAfterGetIds) {
            dispatch(receiveListTableManagementInfo(itemData));
            dispatch(stopAppLoading());
          }
          return itemData;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return {};
      });
  };
}

function validateTableManagement(state, dispatchGeneralError) {
  const { filters } = state;
  const schema = yup.object().shape({
    merchant: yup.object().shape({
      value: yup.number().required(),
    }),
    fromDate: yup
      .date()
      .max(yup.ref('toDate'), trans('from_date_to_date_not_correct'))
      .required(),
    toDate: yup.date().required(),
    status: yup.object().shape({
      value: yup.number().required(),
    }),
  });
  try {
    schema.validateSync(filters);
    return true;
  } catch (err) {
    dispatchGeneralError(err.errors[0]);
    return false;
  }
}

export function getExtendsOrderTableInfo() {
  function genBodyExtendsOrderTableInfo(state, merchantTableInfos) {
    const { filters } = state;
    const { merchant, fromDate, toDate, status, orderCode, phone } = filters;
    const merchantIds = merchant.value !== 0
      ? [merchant.value]
      : merchantTableInfos.map(merchantTableInfo => merchantTableInfo.id);

    const body = {
      merchant_ids: merchantIds,
      from_time: formatStartDateTime(fromDate),
      to_time: formatEndDateTime(toDate),
      order_filter: status.value,
    };
    if (!isEmpty(phone)) {
      body.phone = phone;
    }
    if (!isEmpty(orderCode)) {
      body.order_code = orderCode;
    }
    return body;
  }

  return (dispatch, getState) => {
    const state = getState().table.order;
    const { merchantTableInfos } = getState().app;
    if (
      !validateTableManagement(state, error => dispatch(setGeneralError(error)))
    ) {
      return null;
    }
    const body = genBodyExtendsOrderTableInfo(state, merchantTableInfos);
    dispatch(startAppLoading());
    return request
      .postTableNow('/api/merchant_tool/get_order_statistics', body)
      .then(response => {
        if (isSuccess(response)) {
          const {
            total_adult_number: totalAdultNumber,
            total_arising_amount: totalArisingAmount,
            total_real_adult_number: totalRealAdultNumber,
          } = response.reply;
          dispatch({
            type: actions.RECEIVE_EXTENDED_TABLE_MANAGEMENT_INFOS,
            response: {
              extendedData: {
                totalAdultNumber,
                totalArisingAmount,
                totalRealAdultNumber,
              },
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
        return dispatch(stopAppLoading());
      });
  };
}

export function getListIds(
  isExportExcel = EnumToggleType.OFF.id,
  isShowLoading = true,
) {
  function genBodyTableManagement(state, merchantTableInfos) {
    const { filters } = state;
    const { merchant, fromDate, toDate, status, orderCode, phone } = filters;
    const merchantIds = merchant.value !== 0
      ? [merchant.value]
      : merchantTableInfos.map(merchantTableInfo => merchantTableInfo.id);

    return {
      merchant_ids: merchantIds,
      from_time: formatStartDateTime(fromDate),
      to_time: formatEndDateTime(toDate),
      order_filter: status.value,
      is_export_excel: isExportExcel,
      order_code: orderCode,
      phone,
    };
  }
  return async (dispatch, getState) => {
    const state = getState().table.order;
    const { merchantTableInfos } = getState().app;
    if (
      !validateTableManagement(state, error => dispatch(setGeneralError(error)))
    ) {
      return;
    }
    const { pageSize } = state.table;
    const body = genBodyTableManagement(state, merchantTableInfos);
    if (isShowLoading) {
      dispatch(startAppLoading());
    }
    const urlData = '/api/merchant_tool/get_order_ids';
    if (isExportExcel === EnumToggleType.ON.id) {
      const response = await request.postTableNowFileData(urlData, body);
      if (isSuccess(response)) {
        toast.success(trans('mtn_export_success'));
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
    } else {
      const infoResponse = await request.postTableNow(urlData, body);
      if (isSuccess(infoResponse)) {
        const { order_ids: itemList } = infoResponse.reply;
        const ids = getIdsPaging(itemList, 1, pageSize);
        const itemData = await dispatch(getListInfo(ids, true));
        dispatch(receiveListTableManagementIds(itemList, itemData));
      } else dispatch(setGeneralError(trans(infoResponse.result)));
    }
    if (isShowLoading) {
      dispatch(stopAppLoading());
    }
  };
}

export function updateOrderInfo(requestData) {
  return async (dispatch, getState) => {
    const { filters } = getState().table.order;
    const { isShowTotal } = filters;
    dispatch(startAppLoading());
    const response = await request.postTableNow(
      '/api/merchant_tool/edit_order',
      requestData,
    );
    if (isSuccess(response)) {
      dispatch(
        receiveListTableManagementInfo({
          [requestData.order_id]: response.reply.order_info,
        }),
      );
      if (isShowTotal) {
        dispatch(getExtendsOrderTableInfo());
      }
    } else {
      dispatch(setGeneralError(trans(response.result)));
    }
    dispatch(stopAppLoading());
    return response;
  };
}

export function updateOrderMerchantNote(requestData) {
  return async (dispatch, getState) => {
    const { filters } = getState().table.order;
    const { isShowTotal } = filters;
    dispatch(startAppLoading());
    const response = await request.postTableNow(
      '/api/merchant_tool/update_note',
      requestData,
    );
    if (isSuccess(response)) {
      dispatch(getListInfo([requestData.order_id]));
      if (isShowTotal) {
        dispatch(getExtendsOrderTableInfo());
      }
    } else {
      dispatch(setGeneralError(trans(response.result)));
    }
    dispatch(stopAppLoading());
    return response;
  };
}

export function updateOrderStatus(requestData) {
  return async dispatch => {
    const updateResponse = await request.postTableNow(
      '/api/merchant_tool/update_order_status',
      requestData,
    );
    if (isSuccess(updateResponse)) {
      const itemData = await dispatch(
        getListInfo([requestData.order_id], true),
      );
      if (itemData[requestData.order_id]) {
        dispatch(receiveListTableManagementInfo(itemData));
      }
      return;
    }
    dispatch(setGeneralError(trans(updateResponse.result)));
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/actions.js